<template>
    <div class="creative-team-menu">
        <ul>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0289694/?ref_=instant_nm_1&q=Kevin%20Frakes"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/kevin-frakes_headshot.jpg"
                        alt="Kevin Frakes"
                    />
                    <h2>
                        Kevin Frakes
                    </h2>
                    <h3>
                        Writer, Director
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0626696/?ref_=search_search_result_1"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/gil-netter_headshot.jpg"
                        alt="Gil Netter"
                    />
                    <h2>
                        Gil Netter
                    </h2>
                    <h3>
                        Producer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0000226/?ref_=instant_nm_1&q=will%20smith"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/will-smith_headshot.jpg"
                        alt="Will Smith"
                    />
                    <h2>
                        Will Smith
                    </h2>
                    <h3>
                        Producer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0597821/?ref_=instant_nm_1&q=jon%20mone"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/jon-mone_headshot.jpg"
                        alt="Jon Mone"
                    />
                    <h2>
                        Jon Mone
                    </h2>
                    <h3>
                        Producer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0592073/?ref_=instant_nm_1&q=claudio%20miran"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/claudio-miranda_headshot.jpg"
                        alt="Claudio Miranda"
                    />
                    <h2>
                        Claudio Miranda
                    </h2>
                    <h3>
                        Cinematographer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0914291?rf=cons_nm_more&ref_=cons_nm_more"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/dominic-watkins_headshot.jpg"
                        alt="Dominic Watkins"
                    />
                    <h2>
                        Dominic Watkins
                    </h2>
                    <h3>
                        Production Designer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm3477899/?ref_=instant_nm_1&q=paul%20taz"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/paul-tazewell_headshot.jpg"
                        alt="Paul Tazewell"
                    />
                    <h2>
                        Paul Tazewell
                    </h2>
                    <h3>
                        Costume Designer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0080271?rf=cons_nm_more&ref_=nm_pub_upslb_login&rf=cons_nm_more"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/arjun-bhasin_headshot.jpg"
                        alt="Arjun Bhasin"
                    />
                    <h2>
                        Arjun Bhasin
                    </h2>
                    <h3>
                        Costume Designer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0001980/?ref_=instant_nm_1&q=carter%20burwell"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/carter-burwell_headshot.jpg"
                        alt="Carter Burwell"
                    />
                    <h2>
                        Carter Burwell
                    </h2>
                    <h3>
                        Composer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://www.imdb.com/name/nm2213537/?ref_=nmbio_bio_nm"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/kenna_headshot.jpg"
                        alt="Kenna"
                    />
                    <h2>
                        Kenna
                    </h2>
                    <h3>
                        Music Supervisor
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0150522/?ref_=search_search_result_1"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/denise-chamian_headshot.jpg"
                        alt="Denise Chamian"
                    />
                    <h2>
                        Denise Chamian
                    </h2>
                    <h3>
                        Casting Director
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0424219?rf=cons_nm_more&ref_=cons_nm_more"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/priscilla-john_headshot.jpg"
                        alt="Priscilla John"
                    />
                    <h2>
                        Priscilla John
                    </h2>
                    <h3>
                        Casting Director (UK)
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm4919387/?ref_=instant_nm_1&q=ryan%20kreston"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/ryan-kreston_headshot.jpg"
                        alt="Ryan Kreston"
                    />
                    <h2>
                        Ryan Kreston
                    </h2>
                    <h3>
                        Writer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0015997?rf=cons_nm_more&ref_=cons_nm_more"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/zakaria-alaoui_headshot.jpg"
                        alt="Zakaria Alaoui"
                    />
                    <h2>
                        Zakaria Alaoui
                    </h2>
                    <h3>
                        Producer (Morocco)
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm4504741?rf=cons_nm_more&ref_=cons_nm_more"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/raj-singh_headshot.jpg"
                        alt="Raj Singh"
                    />
                    <h2>
                        Raj Singh
                    </h2>
                    <h3>
                        Executive Producer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm1209773/?ref_=instant_nm_1&q=Manu%20Gargi"
                    title="View Linkedin Profile"
                    target="_blank"
                >
                    <img
                        src="/static/img/manu-gargi_headshot.jpg"
                        alt="Manu Gargi"
                    />
                    <h2>
                        Manu Gargi
                    </h2>
                    <h3>
                        Executive Producer
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0486959?rf=cons_nm_more&ref_=cons_nm_more"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/ben-lanning_headshot.jpg"
                        alt="Ben Lanning"
                    />
                    <h2>
                        Ben Lanning
                    </h2>
                    <h3>
                        1st AD
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0179273/?ref_=instant_nm_1&q=Neil%20Corbould"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/neil-corbould_headshot.jpg"
                        alt="Neil Corbould"
                    />
                    <h2>
                        Neil Corbould
                    </h2>
                    <h3>
                        SFX Supervisor
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm0404404?rf=cons_nm_more&ref_=cons_nm_more"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/stephen-hutchinson_headshot.jpg"
                        alt="Stephen Hutchinson"
                    />
                    <h2>
                        Stephen Hutchinson
                    </h2>
                    <h3>
                        SFX Supervisor
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://www.linkedin.com/in/cgreiwe"
                    title="View Linkedin Profile"
                    target="_blank"
                >
                    <img
                        src="/static/img/craig-greiwe_headshot.jpg"
                        alt="Craig Greiwe"
                    />
                    <h2>
                        Craig Greiwe
                    </h2>
                    <h3>
                        Head of Marketing
                    </h3>
                    <icon
                        :icon="true"
                        glyph="linkedin-color"
                    >
                    </icon>
                </a>
            </li>
            <li>
                <a
                    class="imdb-link"
                    href="https://pro.imdb.com/name/nm1792951?rf=cons_nm_more&ref_=cons_nm_more"
                    title="View IMDB Page"
                    target="_blank"
                >
                    <img
                        src="/static/img/daniel-birt_headshot.jpg"
                        alt="Daniel Birt"
                    />
                    <h2>
                        Daniel Birt
                    </h2>
                    <h3>
                        Set Decorator
                    </h3>
                    <icon
                        :icon="true"
                        glyph="imdb-color"
                    >
                    </icon>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import auth from '../utils/auth';
    import icon from '../components/icon.vue';

    export default {
        name: 'team', // eslint-disable-line vue/component-definition-name-casing
        components: {
            icon
        },
        data() {
            return {
                isAnAlchemist: typeof window !== 'undefined' && auth.currentUser()
            };
        },
        created() {
            const self = this;
            if (self.isAnAlchemist) {
                self.alchemistRole = auth.currentUser().app_metadata.roles[0];
            }
        }
    };
</script>

<style scoped>
    .creative-team-menu {
        margin: 0;
        text-align: center;

        ul {
            column-gap: 3%;
            display: inline-grid;
            grid-template-columns: repeat(3, 1fr);
            list-style: none;
            margin: 0;
            padding: 0;
            text-align: left;

            li {
                display: block;
                min-height: 230px;

                a {
                    display: inline-block;
                    padding: 0 0 0 220px;
                    position: relative;
                    text-align: left;
                    text-decoration: none;

                    img {
                        @mixin position absolute, 0, auto, auto, 0;
                        border-radius: 10px;
                        display: block;
                        width: 200px;
                    }

                    .fpo {
                        background-color: rgba(255, 255, 255, .75);
                        color: var(--color-black);
                        font-size: var(--font-size-button);
                        font-style: italic;
                        left: 0;
                        padding: 10px 0;
                        position: absolute;
                        text-align: center;
                        top: 0;
                        width: 200px;
                    }

                    h2 {
                        color: var(--color-base-font);
                        font-size: var(--font-size-mediumlarge);
                        font-weight: normal;
                        line-height: 1.2;
                        margin: 15px 0 0;
                        word-break: normal;
                    }

                    h3 {
                        color: var(--color-background-darkgray);
                        font-size: var(--font-size-text);
                        margin: 0;
                        word-break: normal;
                    }

                    .svg-linkedin-color,
                    .svg-imdb-color {
                        @mixin transition-animation opacity, 200ms, linear, 0ms;
                        @mixin transition-property 'opacity, filter';
                        @mixin opacity .5;
                        filter: grayscale(100%);
                        font-size: var(--icon-size-imdb);
                        margin: 10px 0 -.2em;
                    }

                    .svg-linkedin-color {
                        font-size: var(--icon-size-linkedin);
                    }

                    &:hover {
                        .svg-linkedin-color,
                        .svg-imdb-color {
                            @mixin opacity 1;
                            filter: grayscale(0);
                        }
                    }
                }
            }

            @media (--breakpoint-xl-max) {
                li {
                    min-height: 190px;

                    a {
                        padding: 0 0 0 140px;

                        img,
                        .fpo {
                            width: 130px;
                        }

                        h2 {
                            margin: 0;
                            white-space: normal;
                            word-spacing: 100vw;
                        }
                    }
                }
            }

            @media (--breakpoint-l-max) {
                li {
                    min-height: 120px;

                    a {
                        padding: 0 0 0 100px;

                        img,
                        .fpo {
                            width: 90px;
                        }

                        h2 {
                            font-size: var(--font-size-medium);
                        }

                        h3 {
                            font-size: var(--font-size-extrasmall);
                        }

                        .svg-imdb-color {
                            font-size: var(--icon-size-smallimdb);
                            margin-top: 5px;
                        }

                        .svg-linkedin-color {
                            font-size: var(--icon-size-linkedin-small);
                        }
                    }
                }
            }

            @media (--breakpoint-m-max) {
                grid-template-columns: repeat(2, 1fr);

                li {
                    a {
                        h2 {
                            word-spacing: unset;
                        }

                        .svg-imdb-color {
                            font-size: var(--icon-size-imdbmedium);
                            margin: 10px 0 -.2em;
                        }

                        .svg-linkedin-color {
                            font-size: var(--icon-size-linkedin-medium);
                        }
                    }
                }
            }

            @media (--breakpoint-s-max) {
                display: inline-block;
                grid-template-columns: repeat(1, 1fr);

                li {
                    min-height: 150px;

                    a {
                        padding: 0 0 0 150px;

                        h2 {
                            font-size: var(--font-size-mediumlarge);
                        }

                        h3 {
                            font-size: var(--font-size-text);
                        }

                        .svg-linkedin-color {
                            font-size: var(--icon-size-linkedin);
                        }

                        .svg-imdb-color {
                            font-size: var(--icon-size-imdb);
                        }

                        img,
                        .fpo {
                            width: 130px;
                        }
                    }
                }
            }
        }
    }
</style>
